import { IoHomeOutline, IoImageOutline, IoText } from 'react-icons/io5';
import { MdInput } from 'react-icons/md';
import { IconType } from 'react-icons';

export const REGEXP = {
  USERNAME: /^[a-zA-Z0-9][a-zA-Z0-9_-]{2,18}[a-zA-Z0-9]$/,
  PASSWORD: /^.{8,32}$/,
  PROJECT_NAME: /^[ㄱ-ㅎ가-힣a-zA-Z0-9][ㄱ-ㅎ가-힣a-zA-Z0-9_-]{0,48}[ㄱ-ㅎ가-힣a-zA-Z0-9]$/,
  DESCRIPTION: /^.{0,100}$/,
};

export const PROJECT_TEMPLATE = {
  basic: {
    name: '기본',
    icon: IoHomeOutline,
    templates: [
      {
        id: 'free',
        title: '자유 템플릿',
        category: 'basic',
        description:
          'Pytorch에서 제공하는 기능들이 담긴 블록들을 자유롭게 연결해 나만의 딥러닝 모델을 만들고 실행시켜보세요.\n만든 모델은 소스코드로 변환되어 자유롭게 사용할 수 있어요.',
      },
    ],
  },
  nlp: {
    name: '자연어',
    icon: IoText,
    templates: [
      {
        id: 'nlp-generation',
        title: '자연어 생성 템플릿',
        category: 'nlp',
        description: '준비중이에요.',
      },
      {
        id: 'nlp-summarization',
        title: '자연어 요약 템플릿',
        category: 'nlp',
        description: '준비중이에요.',
      },
      {
        id: 'nlp-classification',
        title: '자연어 분류 템플릿',
        category: 'nlp',
        description: '준비중이에요.',
      },
    ],
  },
  image: {
    name: '이미지',
    icon: IoImageOutline,
    templates: [
      {
        id: 'image-classification',
        title: '이미지 분류 템플릿',
        category: 'image',
        description: '준비중이에요.',
      },
      {
        id: 'image-detection',
        title: '이미지 탐지 템플릿',
        category: 'image',
        description: '준비중이에요.',
      },
    ],
  },
  input: {
    name: '입출력',
    icon: MdInput,
    templates: [
      {
        id: 'input-n-to-one',
        title: 'N to 1 템플릿',
        category: 'input',
        description: '준비중이에요.',
      },
      {
        id: 'input-n-to-m',
        title: 'N to M 템플릿',
        category: 'input',
        description: '준비중이에요.',
      },
      {
        id: 'input-n-to-n',
        title: 'N to N 템플릿',
        category: 'input',
        description: '준비중이에요.',
      },
      {
        id: 'input-one-to-n',
        title: '1 to N 템플릿',
        category: 'input',
        description: '준비중이에요.',
      },
    ],
  },
} as {
  [index: string]: {
    name: string;
    icon: IconType;
    templates: {
      id: string;
      title: string;
      description: string;
      category: string;
    }[];
  };
};
